<template>
  <div class="card" :style="{background: cardBgColor}">
    <div class="p-3 card-header" style="background-color: transparent;">
      <img :src="iconUrl" />
    </div>
    <div class="p-3 pt-0 card-body">
      <h5 class="mb-0">{{ desc }}</h5>

      <span class="text-xs" style="font-weight: 500;">{{ title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "default-info-card",
  props: {
    cardBgColor: {
      type: String,
      default: '#fff'
    },
    icon_bg: {
      type: String,
      default: "bg-white",
    },
    title: String,
    desc: String,
    iconUrl: String,
  },
};
</script>